/**
 * Card Product Hover Image Gallery
 * Örnek kod mantığına göre görsel değiştirme sistemi
 * Her card için otomatik olarak çalışır
 */
(function () {
  'use strict';
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }
  if (isMobile()) {
    return;
  }
  function cardProductImageSlider(element) {
    // Zaten başlatılmış mı kontrol et
    if (element.classList.contains('slide-active')) {
      return;
    }

    const thumbs = element.querySelectorAll('.card-product__thumbs-image .card-product__thumb');
    const thumbsLength = thumbs.length;

    // Eğer hover görseli yoksa çalıştırma
    if (thumbsLength === 0) {
      return;
    }

    const thumbsWidth = 100 / thumbsLength;
    const imageItemContainer = element.querySelector('.card-product__image-item');
    const imageItem = imageItemContainer ? imageItemContainer.querySelector('img.img-first') : element.querySelector('.card-product__image-item img');
    const imageDots = element.querySelectorAll('.card-product__image-dots button');
    const dotsContainer = element.querySelector('.card-product__image-dots');

    if (!imageItem) {
      return;
    }

    // İlk görseli sakla (mouse leave için) - mevcut görseli sakla (featured image)
    const firstImageSrc = imageItem.src || imageItem.getAttribute('data-src') || imageItem.currentSrc;
    if (firstImageSrc && !imageItem.getAttribute('data-first-src')) {
      imageItem.setAttribute('data-first-src', firstImageSrc);
    }

    // Her thumb'un genişliğini ayarla ve yan yana yerleştir (dinamik - CSS'te tanımlı değil)
    thumbs.forEach(function (thumb, index) {
      thumb.style.left = (index * thumbsWidth) + '%';
      thumb.style.width = thumbsWidth + '%';
    });

    // İlk bullet'ı aktif yap
    if (imageDots.length > 0) {
      imageDots[0].classList.add('active');
    }

    // Her thumb'a mouseenter event'i ekle
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('mouseenter', function () {
        const imageData = this.getAttribute('data-thumb');
        const thumbsIndex = index;

        // Bullet'ları güncelle
        if (imageDots[thumbsIndex]) {
          imageDots.forEach(function (btn) {
            btn.classList.remove('active');
          });
          imageDots[thumbsIndex].classList.add('active');
        }

        // Ana görseli güncelle
        if (imageData) {
          imageItem.style.opacity = '0.7';

          // Yeni görseli yükle
          const tempImg = new Image();
          tempImg.onload = function () {
            imageItem.src = imageData;
            imageItem.srcset = '';
            imageItem.setAttribute('data-src', imageData);
            imageItem.style.opacity = '1';
          };
          tempImg.onerror = function () {
            imageItem.style.opacity = '1';
          };
          tempImg.src = imageData;
        }
      });
    });

    // Mouse enter - bullet'ları göster
    element.addEventListener('mouseenter', function () {
      if (dotsContainer) {
        dotsContainer.style.opacity = '1';
      }
    });

    // Mouse leave olduğunda ilk görsele dön
    element.addEventListener('mouseleave', function () {
      // İlk görseli al (orijinal görsel)
      const firstImageSrc = imageItem.getAttribute('data-first-src') || imageItem.getAttribute('data-src') || imageItem.src;

      if (firstImageSrc && imageItem.src !== firstImageSrc) {
        imageItem.style.opacity = '0.7';

        // İlk görsele dön
        const tempImg = new Image();
        tempImg.onload = function () {
          imageItem.src = firstImageSrc;
          imageItem.srcset = '';
          imageItem.setAttribute('data-src', firstImageSrc);
          imageItem.style.opacity = '1';
        };
        tempImg.onerror = function () {
          imageItem.style.opacity = '1';
        };
        tempImg.src = firstImageSrc;
      }

      // Bullet'ları gizle
      if (dotsContainer) {
        dotsContainer.style.opacity = '0';
      }

      // İlk bullet'ı aktif yap
      imageDots.forEach(function (btn) {
        btn.classList.remove('active');
      });
      if (imageDots[0]) {
        imageDots[0].classList.add('active');
      }
    });

    // İşaretle ki tekrar başlatılmasın
    element.classList.add('slide-active');
  }

  // Tüm card'ları başlat
  function initCardProducts() {
    const imageContainers = document.querySelectorAll('.card-product__image-container:not(.slide-active)');

    imageContainers.forEach(function (container) {
      try {
        cardProductImageSlider(container);
      } catch (e) {
        console.warn('Card image slider initialization error:', e);
      }
    });
  }

  // DOM yüklendiğinde başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardProducts);
  } else {
    initCardProducts();
  }

  // Dinamik içerik için (AJAX yüklemeleri, infinite scroll vb.)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function () {
      setTimeout(initCardProducts, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Periyodik kontrol (örnek kodda olduğu gibi)
  setInterval(function () {
    const imageContainers = document.querySelectorAll('.card-product__image-container:not(.slide-active)');
    if (imageContainers.length > 0) {
      initCardProducts();
    }
  }, 1000);

  // Global erişim için
  window.cardProductImageSlider = cardProductImageSlider;
  window.initCardProducts = initCardProducts;
})();